import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { DevSimulationService } from '../util/dev-simulation.service';

/**
 * Short-circuits outgoing HTTP requests while an in-app simulation is active,
 * so testers can exercise offline and error code paths without Chrome DevTools
 * throttling (which would also block the dev server's lazy-loaded chunks).
 *
 * Registered first so it intercepts before the request actually reaches the
 * network. The offline simulation mimics a status 0 failure (identical to a
 * real connectivity loss), the error simulation mimics a server-side 500.
 */
@Injectable()
export class DevSimulationInterceptor implements HttpInterceptor {
  private readonly devSimulation = inject(DevSimulationService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (this.devSimulation.simulateOffline()) {
      return throwError(
        () =>
          new HttpErrorResponse({
            error: new ProgressEvent('error'),
            status: 0,
            statusText: 'Unknown Error',
            url: request.url,
          }),
      );
    }

    if (this.devSimulation.simulateErrors()) {
      return throwError(
        () =>
          new HttpErrorResponse({
            error: { message: 'Simulated server error (dev test mode)' },
            status: 500,
            statusText: 'Internal Server Error',
            url: request.url,
          }),
      );
    }

    return next.handle(request);
  }
}
